import { ArrowForwardIos } from "@mui/icons-material";
import { Tooltip, IconButton, List } from "@mui/material";
import { useContext, useState, useEffect } from "react";

import DataContext from "../../../../../../../../../context/DataContext";
import PermissionWrapper from "../../../../../../../../global/PermissionWrapper";
import FilterContext from "../../context/FilterContext";

import CaseStatusFilter from "./components/customfilters/CaseStatusFilter";
import FollowUpFilter from "./components/customfilters/FollowUpFilter";
import LawFirmFilter from "./components/customfilters/LawFirmFilter";
import ManagedUserFilter from "./components/customfilters/ManagedUserFilter";
import MedicalStatusFilter from "./components/customfilters/MedicalStatusFilter";
import ProviderFilter from "./components/customfilters/ProviderFilter";

export default function FiltersComp({ isDashboardVersion, setFilterState }) {
  const [toggleFilterMenu, setToggleFilterMenu] = useState(false);
  const { loggedInUser, userRoles } = useContext(DataContext);

  const {
    selectedUsers,
    setSelectedUsers,
    activeUsers,
    setActiveUsers,
    selectedProviders,
    setSelectedProviders,
    activeProviders,
    setActiveProviders,
    selectedFollowUps,
    setSelectedFollowUps,
    activeFollowUps,
    setActiveFollowUps,
    selectedMedicalStatus,
    setSelectedMedicalStatus,
    activeMedicalStatus,
    setActiveMedicalStatus,
    selectedCaseStatus,
    setSelectedCaseStatus,
    activeCaseStatus,
    setActiveCaseStatus,
    selectedLawFirms,
    setSelectedLawFirms,
    activeLawFirms,
    setActiveLawFirms,
    setPaginationUrl,
    setCurrentPage,
  } = useContext(FilterContext);

  useEffect(() => {
    if (!selectedUsers.length) {
      setSelectedUsers([loggedInUser.pk]);
      setActiveUsers([loggedInUser.name]);
    } else if (selectedUsers.length > 1 && selectedUsers.includes(loggedInUser.pk)) {
      setSelectedUsers(selectedUsers.filter((item) => item !== loggedInUser.pk));
      setActiveUsers(activeUsers.filter((item) => item !== loggedInUser.name));
    }
  }, [setSelectedUsers, loggedInUser, setActiveUsers, activeUsers, selectedUsers]);

  const resetPagination = () => {
    setPaginationUrl("");
    setCurrentPage(1);
  };

  return (
    <div
      className={`text-center ${
        isDashboardVersion
          ? !toggleFilterMenu
            ? "z-10 bg-white shadow-lg lg:w-[30%]"
            : "h-fit w-fit"
          : toggleFilterMenu
            ? "z-10 bg-white lg:w-[30%]"
            : "h-fit w-fit"
      }`}
    >
      {!toggleFilterMenu || isDashboardVersion ? (
        <div className={`${!toggleFilterMenu ? "w-full" : "w-fit"} flex flex-row items-start`}>
          <Tooltip title={`${toggleFilterMenu ? "Show Filter Menu" : "Hide Filter Menu"}`}>
            <IconButton
              onClick={() => setToggleFilterMenu(!toggleFilterMenu)}
              className={`m-1 p-4 ${!toggleFilterMenu ? "rotate-180" : ""}`}
            >
              <ArrowForwardIos />
            </IconButton>
          </Tooltip>
          {!toggleFilterMenu ? (
            <div className="flex h-fit w-full flex-col">
              <h1 className={`m-4 flex-1 text-center text-xl font-bold text-purple-600`}>
                Filters
              </h1>
              <div className="z-10 overflow-y-auto bg-white">
                <List>
                  <PermissionWrapper permission={userRoles.permissions.includes("users.view_user")}>
                    <ManagedUserFilter
                      selectedItems={selectedUsers}
                      setSelectedItems={setSelectedUsers}
                      setActiveItems={setActiveUsers}
                      activeItems={activeUsers}
                      resetPagination={resetPagination}
                      setFilterState={setFilterState}
                    />
                  </PermissionWrapper>
                  <ProviderFilter
                    selectedItems={selectedProviders}
                    setSelectedItems={setSelectedProviders}
                    setActiveItems={setActiveProviders}
                    activeItems={activeProviders}
                    resetPagination={resetPagination}
                    setFilterState={setFilterState}
                  />
                  <FollowUpFilter
                    selectedItems={selectedFollowUps}
                    setSelectedItems={setSelectedFollowUps}
                    setActiveItems={setActiveFollowUps}
                    activeItems={activeFollowUps}
                    resetPagination={resetPagination}
                    setFilterState={setFilterState}
                  />
                  <MedicalStatusFilter
                    selectedItems={selectedMedicalStatus}
                    setSelectedItems={setSelectedMedicalStatus}
                    setActiveItems={setActiveMedicalStatus}
                    activeItems={activeMedicalStatus}
                    resetPagination={resetPagination}
                    setFilterState={setFilterState}
                  />
                  <CaseStatusFilter
                    selectedItems={selectedCaseStatus}
                    setSelectedItems={setSelectedCaseStatus}
                    setActiveItems={setActiveCaseStatus}
                    activeItems={activeCaseStatus}
                    resetPagination={resetPagination}
                    setFilterState={setFilterState}
                  />
                  <LawFirmFilter
                    selectedItems={selectedLawFirms}
                    setSelectedItems={setSelectedLawFirms}
                    setActiveItems={setActiveLawFirms}
                    activeItems={activeLawFirms}
                    resetPagination={resetPagination}
                    setFilterState={setFilterState}
                  />
                </List>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
